import * as React from 'react'
import { ReactElement, useMemo } from 'react'
import { useFormikContext } from 'formik'
import FormikField, { findValue, FormikFieldProps } from './FormikField'
import { BaseComboboxProps } from '../Combobox/BaseCombobox'

export default function FormikComboboxField<Values, CP = BaseComboboxProps<any>>(props: FormikFieldProps<CP, Values>): ReactElement {
    const { values, setFieldValue } = useFormikContext<Values>()

    const isFieldAnArray = useMemo(() => Array.isArray(values[props.fieldName]), [values])

    const currentValue = useMemo(() => findValue(values, props.fieldName as string), [values])

    const placeHolderProps = props.size === 'small' ? { ...{ placeholderPrefixKey: '', placeholderKey: '' } } : {}

    return (
        <FormikField<CP, Values>
            {...props}
            componentProps={{
                autoCorrect: 'off',
                required: props.required,
                selectedOptions: isFieldAnArray ? currentValue : [currentValue],
                onOptionSelect: (_, data) =>
                    setFieldValue(props.fieldName as string, isFieldAnArray ? data.selectedOptions : data.selectedOptions?.[0]),
                onOptionsSelect: (_, selectedOptions) =>
                    setFieldValue(props.fieldName as string, isFieldAnArray ? selectedOptions : selectedOptions?.[0]),
                ...placeHolderProps,
                ...(props.componentProps as any),
            }}
        />
    )
}
